// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect } from "react";
import "./Blog.css";
import Header from "../Header";
import Footer from "../footer";
import BookLoader from "../components/BookLoader";
import {
  Link,
  NavLink,
  useNavigate,
  useLocation,
  useParams
} from "react-router-dom";
import { robustFetch } from "../utils/apiUtils";
import SEO from "./SEO";
import { getPostMetrics } from "./utils";
// eslint-disable-next-line no-unused-vars
import { API_ENDPOINTS } from "../config/api";
import { getBlogPostPath } from "../utils/blogRoutes";
import { getAuthToken } from "../utils/auth";
import BlogHeaderAd from "./BlogHeaderAd";
import PaginationControls from "../components/ui/PaginationControls";
import CrossPlatformRSS from "../components/CrossPlatformRSS/CrossPlatformRSS";

// Posts per page - responsive: 12 for laptop/desktop, 10 for mobile
const getPostsPerPage = () => {
  if (typeof window !== "undefined") {
    return window.innerWidth >= 768 ? 12 : 10;
  }
  return 10; // Default for SSR
};

// Dummy comment count fetcher (replace with real API if needed)
function useCommentCount(postId) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!postId) return;
    fetch(API_ENDPOINTS.BLOG.THOUGHTS_COUNT(postId))
      .then((res) => res.json())
      .then((data) => setCount(data.count || 0))
      .catch(() => setCount(0));
  }, [postId]);
  return count;
}

function formatRelativeOrDate(isoString) {
  try {
    if (!isoString) return "Recently";
    const published = new Date(isoString);
    // Check if date is valid
    if (isNaN(published.getTime())) {
      return "Recently";
    }
    const now = new Date();
    const diffMs = now - published;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    if (diffHours < 24) {
      if (diffMinutes < 1) return "just now";
      if (diffMinutes < 60)
        return `${diffMinutes} min${diffMinutes === 1 ? "" : "s"} ago`;
      return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
    }
    return published.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch (_) {
    return "Recently";
  }
}

function HighlightText({ text, query }) {
  if (!query || !text) return <>{text}</>;
  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const parts = text.split(new RegExp(`(${escaped})`, 'gi'));
  const lowerQuery = query.toLowerCase();
  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === lowerQuery ? (
          <mark key={i} className="search-highlight">{part}</mark>
        ) : (
          part
        )
      )}
    </>
  );
}

export const getCategoryConfig = (name) => {
  const normName = (name || "").toLowerCase().trim();
  if (normName.includes("personal"))
    return { icon: "fi-sr-person-simple", color: "#F08D39" };
  if (normName.includes("technology"))
    return { icon: "fi-rr-laptop-mobile", color: "#091413" };
  if (normName.includes("human resource"))
    return { icon: "fi-sr-population", color: "#FF70BF" };
  if (normName.includes("finance"))
    return { icon: "fi-rs-usd-circle", color: "#468432" };
  if (normName.includes("marketing"))
    return { icon: "fi-sr-ad-paid", color: "#C44545" };
  if (normName.includes("business"))
    return { icon: "fi-rr-growth-chart-invest", color: "#9B7E00" };
  if (normName.includes("misc") || normName.includes("miscel"))
    return { icon: "fi-rr-paperclip-vertical", color: "#C2A56D" };
  
  return { icon: "fi-rr-tags", color: "#47b5ff" }; // Default
};

function Design(props) {
  const categoryConfig = getCategoryConfig(props.categoryLabel);
  const authorData = props.authorData || [
    { name: "Hari Vishnu", image: "/images/home_images/Logo.png" },
  ];
  const commentCount = useCommentCount(props.id); // Replace with real count

  // Calculate reading time
  const { readingTime } = getPostMetrics(props.postData || props);

  const defaultThumbnail = process.env.REACT_APP_BLOG_DEFAULT_THUMBNAIL || "https://blog-post-details.s3.eu-north-1.amazonaws.com/Blog+Default+Thumbnail.jpg";
  const thumbnailSrc = props.img || defaultThumbnail;

  if (props.viewLayout === "list") {
    return (
      <Link
        key={props.id}
        to={getBlogPostPath(props.postData || props)}
        className="post_outline list-item flex h-full flex-row items-center gap-[5px] rounded-[16px] border-2 bg-bg p-[5px] no-underline text-text"
        style={{ borderColor: categoryConfig.color }}
      >
        <div className="blog-list-thumb h-auto w-[fit-content] shrink-0 overflow-hidden rounded-[10px]">
          <img 
            className="h-auto w-full object-contain" 
            src={thumbnailSrc} 
            alt={props.title || "Blog post thumbnail"} 
            loading="lazy" 
            onError={(e) => {
              if (e.target.src !== defaultThumbnail) {
                e.target.src = defaultThumbnail;
              }
            }}
          />
        </div>
        <div className="blog-list-details flex min-w-0 flex-1 flex-col relative">
          {props.readArticles?.includes(props.slug) ? (
            <div className="blog-read-status">
              <i className="fi fi-ss-check-circle"></i>
              <span>read</span>
            </div>
          ) : props.viewedArticles?.includes(props.slug) && (
            <div className="blog-read-status viewed">
              <i className="fi fi-ss-eye"></i>
              <span>viewed</span>
            </div>
          )}
          <div className="blog-list-meta-top mb-[0px] flex items-center justify-between gap-[8px]">
            <span className="blog-list-post-number blog-list-post-number-desktop text-[0.82rem] font-[700] text-primary-cyan">#{props.pNumber}</span>
            {readingTime > 0 && (
              <span className="blog-list-reading-time flex items-center gap-[4px] text-[0.78rem] text-[#666]">
                <i className="fi fi-rr-clock"></i>
                {readingTime} min
              </span>
            )}
          </div>
          <p className="blog-list-title line-clamp-2 text-[1rem] font-[700] leading-[1.25] text-post-heading">
            <span className="blog-list-post-number blog-list-post-number-inline text-[0.82rem] font-[700] text-primary-cyan mr-[6px]">#{props.pNumber}</span>
            <HighlightText text={props.title} query={props.searchQuery} />
          </p>
          {props.categoryLabel && (
            <div 
              className="blog-category hidden lg:inline-flex" 
              style={{ 
                color: categoryConfig.color, 
                backgroundColor: `${categoryConfig.color}15`,
                borderColor: `${categoryConfig.color}30` 
              }}
            >
              <i className={`fi ${categoryConfig.icon}`} style={{ color: categoryConfig.color }}></i>
              <span>{props.categoryLabel}</span>
            </div>
          )}

          <div className="blog-list-footer mt-auto flex items-center justify-between gap-[8px]">
            <div className="blog-list-authors flex items-center">
              {authorData.slice(0, 2).map((author, index) => (
                <img
                  key={index}
                  className="blog-list-author-img -ml-[6px] h-[22px] w-[22px] rounded-full border-2 border-bg object-cover first:ml-0"
                  src={author.image}
                  alt={author.name}
                  title={author.name}
                  onError={(e) => {
                    e.target.src = "/images/home_images/Logo.png";
                  }}
                />
              ))}
            </div>
            <span className="blog-list-date text-[0.76rem] text-[#777]">
              {formatRelativeOrDate(props.cdate)}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      key={props.id}
      to={getBlogPostPath(props.postData || props)}
      className="post_outline flex h-full flex-col rounded-[25px] text-text no-underline"
      style={{ borderColor: categoryConfig.color }}
    >
      <div className="blog-thumbnail-container relative">
        <div className="blog-image-wrapper relative m-[1%_auto_2%] block w-[98%] overflow-hidden rounded-[17px] border border-slider h-auto">
            <img 
              className="image block h-auto w-full object-contain object-center transition-transform duration-300 ease-in-out" 
              src={thumbnailSrc} 
              alt={props.title || "Blog post thumbnail"} 
              loading="lazy" 
              onError={(e) => {
                if (e.target.src !== defaultThumbnail) {
                  e.target.src = defaultThumbnail;
                }
              }}
            />
        </div>
        <span className="post-number-badge absolute left-[12px] top-[12px] z-20 rounded-[8px] bg-primary-cyan px-[10px] py-[6px] text-[1.1em] font-[700] text-bg shadow-[0_2px_8px_rgba(0,0,0,0.2)]">{props.pNumber}</span>
        {props.readArticles?.includes(props.slug) ? (
          <div className="blog-read-status">
            <i className="fi fi-ss-check-circle"></i>
            <span>read</span>
          </div>
        ) : props.viewedArticles?.includes(props.slug) && (
            <div className="blog-read-status viewed">
              <i className="fi fi-ss-eye"></i>
              <span>viewed</span>
            </div>
        )}
      </div>
      <div className="post_details flex flex-row grow">
        <div className="Heading grow p-[0.4rem_0.5rem_0.5rem]">
          <p className="title m-0 text-[1.05rem] font-[700] leading-[1.35] text-post-heading"><HighlightText text={props.title} query={props.searchQuery} /></p>
        </div>
      </div>
      {props.categoryLabel && (
        <div className="blog-category-container hidden lg:block px-[0.8rem] mb-[4px]">
          <div 
            className="blog-category"
            style={{ 
              color: categoryConfig.color, 
              backgroundColor: `${categoryConfig.color}15`,
              borderColor: `${categoryConfig.color}30` 
            }}
          >
            <i className={`fi ${categoryConfig.icon}`} style={{ color: categoryConfig.color }}></i>
            <span>{props.categoryLabel}</span>
          </div>
        </div>
      )}

      <div className="blog-info-row mt-auto flex items-center gap-[8px] p-[0_0.6rem] text-[0.8rem] text-[#666]">
        <span className="blog-info-date">
          {formatRelativeOrDate(props.cdate)}
        </span>
        <div className="blog-info-authors ml-auto flex items-center">
          {authorData.slice(0, 3).map((author, index) => (
            <img
              key={index}
              className="blog-author-img -ml-[8px] h-[24px] w-[24px] rounded-full border-2 border-bg object-cover first:ml-0"
              src={author.image}
              alt={`${author.name} profile`}
              title={author.name}
              onError={(e) => {
                e.target.src = "/images/home_images/Logo.png";
              }}
            />
          ))}
          {authorData.length > 3 && (
            <div className="blog-author-count -ml-[8px] flex h-[24px] w-[24px] items-center justify-center rounded-full border-2 border-bg bg-[#6c757d] text-[0.6em] font-[700] text-white">+{authorData.length - 3}</div>
          )}
        </div>
        {commentCount > 0 && (
          <span className="blog-info-comments flex items-center gap-[3px]">
            <i className="fi fi-rr-comment-alt"></i>
            {commentCount}
          </span>
        )}
        {readingTime > 0 && (
          <span className="blog-info-reading-time flex items-center gap-[3px]">
            <i className="fi fi-rr-clock"></i>
            {readingTime} min
          </span>
        )}
        {props.hasPodcast && (
          <span className="blog-info-podcast">
            <i className="fi fi-sr-podcast"></i>
          </span>
        )}
      </div>
    </Link>
  );
}

export default function Blog() {
  const [currentPage, setCurrentPage] = useState(() => {
    const saved = sessionStorage.getItem('blog_last_page');
    return saved ? parseInt(saved, 10) : 1;
  });

  useEffect(() => {
    sessionStorage.setItem('blog_last_page', currentPage.toString());
  }, [currentPage]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  const [cursors, setCursors] = useState({ 1: null }); // eslint-disable-line no-unused-vars
  const [allPosts, setAllPosts] = useState({}); // eslint-disable-line no-unused-vars
  const [postsPerPage, setPostsPerPage] = useState(getPostsPerPage()); // Responsive posts per page

  // Update posts per page on window resize (for laptop/desktop vs mobile)
  useEffect(() => {
    const handleResize = () => {
      setPostsPerPage(getPostsPerPage());
    };

    window.addEventListener("resize", handleResize);
    // Set initial value
    setPostsPerPage(getPostsPerPage());

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ========== READ & VIEWED STATUS STATE ==========
  const [readArticles, setReadArticles] = useState([]);
  const [viewedArticles, setViewedArticles] = useState([]);

  useEffect(() => {
    const fetchArticlesStatus = async () => {
      const userToken = getAuthToken();
      let serverReadSlugs = [];
      let serverViewedSlugs = [];
      
      if (userToken) {
        try {
          // Fetch Read
          const readRes = await fetch(API_ENDPOINTS.USER.READ_ARTICLES, {
            headers: { "Authorization": `Bearer ${userToken}` }
          });
          const readData = await readRes.json();
          if (readData.success) serverReadSlugs = readData.data || [];

          // Fetch Viewed
          const viewedRes = await fetch(API_ENDPOINTS.USER.VIEWED_ARTICLES, {
            headers: { "Authorization": `Bearer ${userToken}` }
          });
          const viewedData = await viewedRes.json();
          if (viewedData.success) serverViewedSlugs = viewedData.data || [];
        } catch (err) {
          console.error("Error fetching articles status from server:", err);
        }
      }

      // Guest/Local logic
      let localReadSlugs = [];
      let localViewedSlugs = [];
      try {
        localReadSlugs = JSON.parse(localStorage.getItem("readArticles") || "[]");
        localViewedSlugs = JSON.parse(localStorage.getItem("viewedArticles") || "[]");
      } catch (err) {
        console.error("Error reading local status:", err);
      }

      setReadArticles(Array.from(new Set([...serverReadSlugs, ...localReadSlugs])));
      setViewedArticles(Array.from(new Set([...serverViewedSlugs, ...localViewedSlugs])));
    };

    fetchArticlesStatus();
    
    // Refresh when status is updated
    window.addEventListener('readArticlesUpdated', fetchArticlesStatus);
    return () => window.removeEventListener('readArticlesUpdated', fetchArticlesStatus);
  }, []);

  // ========== SEARCH STATE ==========
  const [searchQuery, setSearchQuery] = useState("");
  const [searchFocused, setSearchFocused] = useState(false);
  const [hasHeaderAd, setHasHeaderAd] = useState(true);

  // ========== SORT STATE ==========
  const [sortBy, setSortBy] = useState("number"); // "number" | "date"
  const [sortOrder, setSortOrder] = useState("desc"); // "asc" | "desc"

  // ========== LAYOUT TOGGLE STATE ==========
  const [viewLayout, setViewLayout] = useState(() => {
    return "grid";
  });

  // ========== FILTERING STATE ==========
  const [viewType, setViewType] = useState("all"); // 'all', 'author-wise', 'category-wise'
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedAuthor, setSelectedAuthor] = useState(null);

  // ========== MONGODB CATEGORIES FETCHING START ==========
  const [mongoCategories, setMongoCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true); // eslint-disable-line no-unused-vars

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setCategoriesLoading(true);
        const response = await robustFetch(API_ENDPOINTS.BLOG.CATEGORIES);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const categoriesData = await response.json();

        if (categoriesData && Array.isArray(categoriesData)) {
          setMongoCategories(categoriesData);
        } else {
          setMongoCategories([]);
        }
        setCategoriesLoading(false);
      } catch (err) {
        console.error("Error fetching categories:", err);
        setMongoCategories([]);
        setCategoriesLoading(false);
      }
    };

    fetchCategories();
  }, []);
  // ========== MONGODB CATEGORIES FETCHING END ==========

  // ========== MONGODB POSTS FETCHING START ==========
  const [mongoPosts, setMongoPosts] = useState([]);
  const [mongoLoading, setMongoLoading] = useState(true);
  const [mongoError, setMongoError] = useState(null); // eslint-disable-line no-unused-vars
  const [loadingProgress, setLoadingProgress] = useState(null);

  // Fetch posts from MongoDB BlogDb
  const { state } = useLocation();

  useEffect(() => {
    if (state && state.selectedCategory && mongoCategories.length > 0) {
      setViewType("category-wise");
      // Find the category in mongoCategories to ensure we have the correct ID for comparison
      const category = mongoCategories.find(c => 
        (c._id && state.selectedCategory._id && String(c._id) === String(state.selectedCategory._id)) || 
        (c.slug && state.selectedCategory.slug && c.slug === state.selectedCategory.slug) ||
        (c.name && state.selectedCategory.name && c.name === state.selectedCategory.name)
      );
      if (category) {
        setSelectedCategory(category);
        setCurrentPage(1);
      }
    }
  }, [state, mongoCategories]);

  useEffect(() => {
    const fetchMongoPosts = async () => {
      try {
        setMongoLoading(true);
        setMongoError(null);
        
        const response = await robustFetch(API_ENDPOINTS.BLOG.POSTS);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const postsData = await response.json();

        // Filter only published posts and convert to Hygraph-like format
        if (postsData && Array.isArray(postsData)) {
          // Filter for isPublished === true only
          const publishedPosts = postsData.filter(
            (post) => post.isPublished === true
          );

          if (publishedPosts.length > 0) {
            // Convert MongoDB posts to Hygraph-like format
            const formattedPosts = publishedPosts.map((post) => {
              return {
              node: {
                id: post._id || post.id,
                postNumber: post.postNumber || 0,
                createdAt: post.createdAt,
                slug: post.slug,
                title: post.title,
                excerpt: "", // Removed for performance
                coverImage: post.coverImage || { url: "" },
                // Category from MongoDB - can be populated object with _id, name, slug OR just _id string
                // Preserve the original structure for _id matching
                categories: post.category
                  ? Array.isArray(post.category)
                    ? post.category
                    : [post.category]
                  : [],
                // Removed postTopic for performance
                postTopic: null,
                content: null,
                readingTime: post.readingTime || 0,
                author: post.author || null,
                photoCollection: [],
                isPublished: post.isPublished,
                hasPodcast: post.hasPodcast || false,
              },
            };
          });

            // Ensure uniqueness by post number and slug within MongoDB posts
            const uniquePosts = [];
            const seenSlugs = new Set();
            const seenPostNumbers = new Set();

            formattedPosts.forEach((post) => {
              const slug = post.node && post.node.slug ? post.node.slug : "";
              const postNumber =
                post.node && post.node.postNumber ? post.node.postNumber : null;

              // Only add if slug and post number are unique
              if (
                slug &&
                !seenSlugs.has(slug) &&
                postNumber !== null &&
                !seenPostNumbers.has(postNumber)
              ) {
                uniquePosts.push(post);
                seenSlugs.add(slug);
                seenPostNumbers.add(postNumber);
              }
            });

            setMongoPosts(uniquePosts);
          } else {
             setMongoPosts([]);
          }
        } else {
          setMongoPosts([]);
        }
        setMongoLoading(false);
      } catch (err) {
        console.error("Error fetching MongoDB posts:", err);
        setMongoError(err);
        setMongoPosts([]);
        setMongoLoading(false);
      }
    };

    fetchMongoPosts();
  }, []);
  // ========== MONGODB POSTS FETCHING END ==========

  // Extract unique categories and sort alphabetically
  // eslint-disable-next-line no-unused-vars
  const uniqueCategories = React.useMemo(() => {
    const categorySet = new Set();
    const categoryMap = new Map();

    // Extract categories from MongoDB posts
    if (mongoPosts.length > 0) {
      mongoPosts.forEach((post) => {
        if (post.node && post.node.categories) {
          const categories = Array.isArray(post.node.categories)
            ? post.node.categories
            : [post.node.categories];

          categories.forEach((category) => {
            if (category && category.name && category.slug) {
              categorySet.add(category.name);
              categoryMap.set(category.name, category.slug);
            }
          });
        }
      });
    }

    return Array.from(categorySet)
      .sort((a, b) => a.localeCompare(b)) // Sort alphabetically
      .map((name) => ({
        name,
        slug: categoryMap.get(name),
      }));
  }, [mongoPosts]);

  // Combine MongoDB and Hygraph posts - show both
  // eslint-disable-next-line react-hooks/exhaustive-deps
  let allCombinedPosts = [];

  // Start with MongoDB posts (already filtered for isPublished === true)
  if (mongoPosts.length > 0) {
    allCombinedPosts = [...mongoPosts];
  }

  // Apply filtering based on viewType, selectedCategory, and selectedAuthor
  let filteredPosts = allCombinedPosts;

  if (viewType === "category-wise" && selectedCategory) {
    // eslint-disable-next-line no-unused-vars
    const targetSlug = (
      selectedCategory.slug ||
      (selectedCategory.name ? selectedCategory.name.toLowerCase() : "") ||
      ""
    )
      .trim()
      .toLowerCase();

    filteredPosts = allCombinedPosts.filter((post) => {
      if (!post.node) return false;
      const categories = post.node.categories || [];
      const categoryArray = Array.isArray(categories)
        ? categories
        : [categories];

      return categoryArray.some((cat) => {
        if (!cat) return false;

        // Handle MongoDB format: cat can be an object with _id, or just _id string
        let categoryId = "";

        if (cat && typeof cat === "object" && cat !== null) {
          // Category object with _id property
          categoryId = cat._id ? String(cat._id) : "";
        } else if (cat && typeof cat === "string") {
          // Category is just an _id string
          categoryId = String(cat);
        }

        // Match by _id - compare with selected category's _id
        if (selectedCategory._id && categoryId) {
          if (String(categoryId) === String(selectedCategory._id)) {
            return true;
          }
        }

        return false;
      });
    });
  } else if (viewType === "author-wise" && selectedAuthor) {
    filteredPosts = allCombinedPosts.filter((post) => {
      if (!post.node || !post.node.author) return false;
      const authors = Array.isArray(post.node.author)
        ? post.node.author
        : [post.node.author];
      return authors.some((author) => {
        if (!author || typeof author !== "object") return false;
        const authorId = author._id || author.id || "";
        const authorName = author.name || "";
        return (
          String(authorId) === String(selectedAuthor._id || selectedAuthor.id) ||
          authorName === selectedAuthor.name
        );
      });
    });
  }

  // Apply search filter
  if (searchQuery.trim()) {
    const lowerQuery = searchQuery.trim().toLowerCase();
    filteredPosts = filteredPosts.filter((post) => {
      if (!post.node) return false;
      const title = (post.node.title || "").toLowerCase();
      return title.includes(lowerQuery);
    });
  }

  // Sort by selected field and direction
  filteredPosts.sort((a, b) => {
    if (sortBy === "date") {
      const dateA = a.node && a.node.createdAt ? new Date(a.node.createdAt).getTime() : 0;
      const dateB = b.node && b.node.createdAt ? new Date(b.node.createdAt).getTime() : 0;
      return sortOrder === "desc" ? dateB - dateA : dateA - dateB;
    }
    const numA = a.node && a.node.postNumber ? a.node.postNumber : 0;
    const numB = b.node && b.node.postNumber ? b.node.postNumber : 0;
    return sortOrder === "desc" ? numB - numA : numA - numB;
  });

  // Get unique authors for dropdown
  const uniqueAuthors = React.useMemo(() => {
    const authorMap = new Map();
    allCombinedPosts.forEach((post) => {
      if (post.node && post.node.author) {
        const authors = Array.isArray(post.node.author)
          ? post.node.author
          : [post.node.author];
        authors.forEach((author) => {
          if (!author || typeof author !== "object") return;
          const authorId = author._id || author.id || "";
          const authorName = author.name || "Unknown";
          if (authorId && !authorMap.has(authorId)) {
            authorMap.set(authorId, {
              _id: authorId,
              id: authorId,
              name: authorName,
            });
          }
        });
      }
    });
    return Array.from(authorMap.values()).sort((a, b) =>
      a.name.localeCompare(b.name)
    );
  }, [allCombinedPosts]);

  // Calculate total pages - use filtered posts count
  const totalCount = filteredPosts.length;
  const totalPages = Math.ceil(totalCount / postsPerPage);

  // Reset page if it exceeds total pages
  useEffect(() => {
    if (totalPages > 0 && currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  // Apply pagination to filtered posts
  const startIndex = (currentPage - 1) * postsPerPage;
  const endIndex = startIndex + postsPerPage;
  const currentPosts = filteredPosts.slice(startIndex, endIndex);

  // Show loader only if we're loading and have no posts at all
  if (mongoLoading && allCombinedPosts.length === 0) {
    return <BookLoader progress={loadingProgress} />;
  }

  // If no posts at all (not due to search/filter), show full-page empty state
  if (allCombinedPosts.length === 0 && !mongoLoading) {
    return (
      <>
        <Header />
        <div
          style={{ padding: "20px", textAlign: "center", minHeight: "60vh" }}
        >
          <h2>No Blog Posts Available</h2>
          <p>There are no blog posts available at this time.</p>
        </div>
        <Footer />
      </>
    );
  }

  const all_data = currentPosts
    .map((track) => {
      try {
        // Safely extract category slug - handle both MongoDB and Hygraph formats (use slug for URL)
        let categorySlug = "uncategorized";
        if (
          track.node.categories &&
          Array.isArray(track.node.categories) &&
          track.node.categories.length > 0
        ) {
          // Hygraph format: categories is an array
          const firstCategory = track.node.categories[0];
          if (firstCategory && firstCategory.slug) {
            categorySlug = firstCategory.slug;
          } else if (firstCategory && firstCategory.name) {
            categorySlug = firstCategory.name.toLowerCase();
          }
        } else if (track.node.category) {
          // MongoDB format: category can be object or array
          const category = Array.isArray(track.node.category)
            ? track.node.category[0]
            : track.node.category;
          if (category && typeof category === "object" && category !== null) {
            // Category is populated object with _id, name, slug
            if (category.slug) {
              categorySlug = category.slug;
            } else if (category.name && typeof category.name === "string") {
              categorySlug = category.name.toLowerCase();
            }
          } else if (category && typeof category === "string") {
            // Category is just a string (shouldn't happen if populated, but handle it)
            categorySlug = category.toLowerCase();
          }
        }

        // Safely extract author data - handle both MongoDB and Hygraph formats
        let authorData = [
          { name: "Hari Vishnu", image: "/images/home_images/Logo.png" },
        ];
        if (track.node.author) {
          if (Array.isArray(track.node.author)) {
            // Hygraph format: author is an array
            authorData = track.node.author
              .map((author) => ({
                name: author && author.name ? author.name : "Unknown Author",
                image:
                  author &&
                  author.image &&
                  Array.isArray(author.image) &&
                  author.image.length > 0
                    ? author.image[0].url
                    : author && author.image && author.image.url
                    ? author.image.url
                    : "/images/home_images/Logo.png",
              }))
              .filter(
                (a) =>
                  a.name !== "Unknown Author" ||
                  a.image !== "/images/home_images/Logo.png"
              );
          } else if (typeof track.node.author === "object") {
            // MongoDB format: author is a populated object
            const author = track.node.author;
            authorData = [
              {
                name: author.name || "Hari Vishnu",
                image:
                  author.image &&
                  Array.isArray(author.image) &&
                  author.image.length > 0
                    ? author.image[0].url
                    : author.image && author.image.url
                    ? author.image.url
                    : "/images/home_images/Logo.png",
              },
            ];
          }
        }

        // Safely extract post topic
        const postTopic = track.node.postTopic
          ? typeof track.node.postTopic === "object" &&
            track.node.postTopic.topic
            ? track.node.postTopic.topic
            : typeof track.node.postTopic === "string"
            ? track.node.postTopic
            : ""
          : "";

        return (
          <Design
            key={track.node.id}
            id={track.node.id}
            img={(track.node.coverImage && track.node.coverImage.url) || ""}
            title={track.node.title || "Untitled"}
            excerpt={track.node.excerpt || track.node.description || ""}
            cdate={track.node.createdAt || ""}
            slug={track.node.slug || ""}
            pNumber={track.node.postNumber || 0}
            hasPodcast={track.node.hasPodcast}
            pTopic={postTopic}
            postData={track.node}
            searchQuery={searchQuery}
            viewLayout={viewLayout}
            authorData={
              authorData.length > 0
                ? authorData
                : [
                    {
                      name: "Hari Vishnu",
                      image: "/images/home_images/Logo.png",
                    },
                  ]
            }
            categoryName={categorySlug}
            categoryLabel={
              track.node.categories && track.node.categories.length > 0
                ? track.node.categories[0].name
                : track.node.category
                ? Array.isArray(track.node.category)
                  ? track.node.category[0].name || track.node.category[0]
                  : track.node.category.name || track.node.category
                : ""
            }
            readArticles={readArticles}
            viewedArticles={viewedArticles}
          />
        );
      } catch (error) {
        console.error("Error rendering post:", error, track);
        return null;
      }
    })
    .filter(Boolean);

  const hasNextPage = currentPage < totalPages; // eslint-disable-line no-unused-vars

  // Pagination data processed

  const blogListSchema = {
    "@context": "https://schema.org",
    "@type": "Blog",
    "name": "Hari Vishnu Blog",
    "description": "Articles, resources & insights on technology, business, AI, programming, and personal growth by Hari Vishnu.",
    "url": "https://blog.harivishnu.in",
    "inLanguage": "en-IN",
    "author": {
      "@type": "Person",
      "name": "Hari Vishnu",
      "url": "https://www.harivishnu.in/contact"
    },
    "publisher": {
      "@type": "Person",
      "name": "Hari Vishnu",
      "url": "https://www.harivishnu.in"
    }
  };

  return (
    <>
      <SEO
        title="Blog – Articles, Resources & Insights"
        description="Read the latest articles, and insights on technology, business, artificial intelligence, programming, and personal growth by Hari Vishnu."
        url="https://blog.harivishnu.in"
        keywords="blog, articles, technology, business, AI, programming, personal growth, insights"
        favicon="/images/home_images/Blog-page-Logo.png"
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(blogListSchema) }} />
      <Header />
      <div className="blog-header">
          <div className={`blog-header-top-row${hasHeaderAd ? '' : ' no-active-ad'}`}>
            <div className={`blog-header-text${hasHeaderAd ? '' : ' centered'}`}>
            <h1>Blog</h1>
          </div>
            <div className={`blog-header-ad-wrapper${hasHeaderAd ? '' : ' is-hidden'}`}>
              <BlogHeaderAd onAvailabilityChange={setHasHeaderAd} />
          </div>
        </div>
        <CrossPlatformRSS
          items={[
            { 
              link: "/rss.xml", 
              label: "RSS Feed", 
              icon: "fi fi-sr-rss", 
              color: "#ff9800" 
            },
            { 
              link: "https://feedly.com/i/subscription/feed/https://www.harivishnu.in/rss.xml", 
              label: "Follow on Feedly", 
              icon: "fi fi-sr-book-bookmark", 
              color: "#2bb24c" 
            },
            {
              label: "Copy Link",
              icon: "fi fi-rr-copy-alt",
              isCopy: true,
              copyValue: "/rss.xml",
              color: "#5c6bc0"
            }
          ]}
        />
        <div className="blog-header-filters w-full">
          <div className={`blog-search-wrapper${searchFocused ? " is-focused" : ""}`}>
            <div className="blog-search-inner">
              <i className="fi fi-rr-search"></i>
              <span className="blog-search-sep"></span>
              <input
                type="text"
                className="blog-search-input"
                placeholder="Search posts..."
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                }}
                onFocus={() => setSearchFocused(true)}
                onBlur={() => setSearchFocused(false)}
              />
              {searchQuery && (
                <button
                  className="blog-search-clear flex h-[22px] w-[22px] items-center justify-center rounded-full border-none bg-transparent text-[#666] hover:bg-black/5"
                  onClick={() => {
                    setSearchQuery("");
                    setCurrentPage(1);
                  }}
                  aria-label="Clear search"
                  type="button"
                >
                  <i className="fi fi-rr-cross-small"></i>
                </button>
              )}
            </div>
          </div>
          <div className="blog-dropdowns-row">
          <div className="sort-feature-container">
            <span className="sort-label">View:</span>
            <select
              value={viewType}
              onChange={(e) => {
                setViewType(e.target.value);
                setSelectedCategory(null);
                setSelectedAuthor(null);
                setCurrentPage(1);
              }}
              className="sort-select"
            >
              <option value="all">All Posts</option>
              <option value="author-wise">Author-wise</option>
              <option value="category-wise">Category-wise</option>
            </select>
          </div>
          {viewType === "author-wise" && (
            <div className="sort-feature-container">
              <span className="sort-label">Author:</span>
              <select
                value={selectedAuthor ? selectedAuthor._id : ""}
                onChange={(e) => {
                  const authorId = e.target.value;
                  const author = uniqueAuthors.find((a) => a._id === authorId);
                  setSelectedAuthor(author || null);
                  setCurrentPage(1);
                }}
                className="sort-select border-none bg-transparent text-[0.85rem] text-[#333] outline-none"
              >
                <option value="">Select Author</option>
                {uniqueAuthors.map((author) => (
                  <option key={author._id} value={author._id}>
                    {author.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          {viewType === "category-wise" && (
            <div className="sort-feature-container">
              <span className="sort-label">Categories:</span>
              <select
                value={selectedCategory ? selectedCategory._id : ""}
                onChange={(e) => {
                  const categoryId = e.target.value;
                  const category = mongoCategories.find(
                    (c) => c._id === categoryId
                  );
                  setSelectedCategory(category || null);
                  setCurrentPage(1);
                }}
              className="sort-select"
            >
              <option value="">Select Category</option>
              {mongoCategories.map((category) => (
                <option key={category._id} value={category._id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>
          )}
          <div className="sort-feature-container">
            <span className="sort-label">Sort:</span>
            <select
              className="sort-select"
              value={sortBy}
              onChange={(e) => { setSortBy(e.target.value); setCurrentPage(1); }}
            >
              <option value="number">Number</option>
              <option value="date">Date</option>
            </select>
            <button
              className="sort-order-btn"
              type="button"
              onClick={() => { setSortOrder((o) => (o === "asc" ? "desc" : "asc")); setCurrentPage(1); }}
              title={sortOrder === "asc" ? "Ascending" : "Descending"}
            >
              <i className={`fi fi-rr-arrow-${sortOrder === "asc" ? "up" : "down"}`}></i>
              <span className="sort-order-letter">{sortOrder === "asc" ? "A" : "D"}</span>
            </button>
          </div>
          <div className="podcast-align-toggle-container">
            <span className="podcast-filter-label">Layout</span>
            <button
              className="podcast-align-toggle-btn"
              type="button"
              onClick={() => setViewLayout((v) => (v === "grid" ? "list" : "grid"))}
              title={viewLayout === "grid" ? "Switch to List view" : "Switch to Grid view"}
            >
              {viewLayout === "grid" ? (
                <i className="fi fi-sr-rectangle-list"></i>
              ) : (
                <i className="fi fi-sr-grid"></i>
              )}
            </button>
          </div>
          </div>
        </div>
      </div>
      <div className="blog-main-layout mx-auto my-[2rem] flex w-[95%] max-w-[2000px] flex-row items-start gap-[1rem] max-[1024px]:w-[96%] max-[1024px]:flex-col">
        <div className="blog-content-area min-w-0 flex-1">
          <div className={`all_post_area grid w-full grid-cols-4 items-stretch gap-[16px] font-['Lora',serif] ${viewLayout === "list" ? " list-layout grid-cols-1" : ""}`}>
            {all_data.length > 0 ? all_data : (
              <div className="blog-no-results col-span-full flex flex-col items-center justify-center rounded-[16px] border-2 border-dashed border-slider bg-bg p-[24px] text-center text-[#666]">
                <i className="fi fi-rr-search"></i>
                <p>No posts found{searchQuery.trim() ? ` for "${searchQuery.trim()}"` : ""}.</p>
              </div>
            )}
          </div>
          <PaginationControls
            currentPage={currentPage}
            totalPages={totalPages}
            containerClassName="pagination mt-[1rem] flex items-center justify-center gap-[12px]"
            buttonClassName="rounded-[8px] border border-slider bg-bg px-[12px] py-[6px] text-[0.9rem] text-text disabled:opacity-50"
            infoClassName="text-[0.9rem] text-text"
            onFirst={() => setCurrentPage(1)}
            onPrevious={() => {
              if (currentPage > 1) {
                setCurrentPage(currentPage - 1);
              }
            }}
            onNext={() => {
              if (currentPage < totalPages) {
                setCurrentPage(currentPage + 1);
              }
            }}
            onLast={() => setCurrentPage(totalPages)}
          />
        </div>
      </div>
      <Footer />
    </>
  );
}
